module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b431bfb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Document/Document.vue
// module id = 1384
// module chunks = 0